export { Accordion } from "./accordion.component";
export type { IAccordionProps } from "./accordion.component";
